export default "__VITE_PUBLIC_ASSET__28bdcb6b__"